export default {
  'userEmulation.new': 'New Emulation',
  'userEmulation.start': 'Start Emulation',
  'userEmulation.title': 'user emulation',
  'userEmulation.logout': 'Log Out',
  'userEmulation.description': 'Select customer and user to emulate.',
  'userEmulation.description2': 'Some actions will not be available for emulation.',
  'userEmulation.workflowFor': 'Emulation for',
  'userEmulation.note': 'in progress. Some actions restricted.',
  'userEmulation.flowError': 'Action not available in emulation session',
  'userEmulation.noPermission': 'You are not permitted for Customer Emulation.',
  'userEmulation.checkPermission': 'Please check your permissions.',
  'userEmulation.selectCustomer.enterNCharacters': 'Enter <%=length %> characters or more',
  'userEmulation.selectCustomer.label': 'Select customer'
};
